import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { STRIPE_PUBLIC_KEY } from 'Settings';

import AddPaymentMethodForm from 'Containers/paymentForms/AddPaymentMethodForm';
import ContentFrame from 'Components/ContentFrame';
import BackLink from 'Components/BackLink';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from '../../settings/route-strings';
import Loading from 'Components/Loading';
import { getActiveUser, getActiveSchool } from 'Store/reducers';
import { connect } from 'react-redux';

function PaymentMethodSettings(props) {
  const { activeUser, activeSchool } = props;
  if (!activeUser || !activeSchool) return <Loading />;
  const schoolId = activeSchool.id;
  console.log('schoolId', schoolId);
  return (
    <StripeProvider apiKey={STRIPE_PUBLIC_KEY}>
      <Elements
        fonts={[
          {
            family: 'AvenirLTStd-Roman',
            src:
              'url(https://schools-cdn.tinybop.com/stripe-fonts/33F6F0_2_0.woff)',
          },
        ]}
      >
        <ContentFrame
          size="medium"
          pageType="static-modal"
          backLink={
            <BackLink
              label={
                <ConnectedFormattedMessage id="add_payment_method_form.back_link" />
              }
              route={ROUTES.SETTINGS_SUBSCRIPTION}
              type="content-frame-medium"
            />
          }
        >
          <AddPaymentMethodForm schoolId={schoolId} />
        </ContentFrame>
      </Elements>
    </StripeProvider>
  );
}

const mapStateToProps = (state) => ({
  activeUser: getActiveUser(state),
  activeSchool: getActiveSchool(state),
});

export default connect(mapStateToProps, {})(PaymentMethodSettings);
